import classnames from 'classnames/bind';
import { memo } from 'react';
import { CoefficientTableCell } from '@/pages/supplies-management/_components/coefficient-table-cell';
import { TPartOfCoefficientReport } from '@/pages/supplies-management/children/warehouses-limits/redux/warehouses-limits-module/types';
import { getFormattedTableCells } from './_utils/get-formatted-table-cells';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'Table-cell-item';

type TTableCellItemProps = {
  item: TPartOfCoefficientReport;
  maxLengthOfData: number;
  isPalette?: boolean;
  costForPalette?: number;
};

export const TableCellItem = memo(
  ({
    item,
    maxLengthOfData,
    isPalette,
    costForPalette,
  }: TTableCellItemProps) => {
    return (
      <>
        {getFormattedTableCells({ item, maxLengthOfData }).map(
          ({ coefficient }, index) => {
            return (
              <div key={index} className={cn(BLOCK_NAME)}>
                <CoefficientTableCell
                  costForPalette={costForPalette}
                  isPalette={isPalette}
                  row={{ paidAcceptanceCoefficient: coefficient }}
                  textSize="h5-bold"
                />
              </div>
            );
          },
        )}
      </>
    );
  },
);
